<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="États des dossiers"
                createIconText="Ajouter un état"
                importDatasourceName="foldersStates"
                (created)="onFolderStateCreated()"
                (exported)="onFolderStatesExported()"
                (imported)="onFolderStatesImported()"
                (helped)="onFolderStatesHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-folder-states-list
            #itemsList
            (itemSelected)="onFolderStateSelected($event)"
            (itemDisplayed)="onFolderStateDisplayed($event)"
            (itemEdited)="onFolderStateEdited($event)"
            (itemDeleted)="onFolderStateDeleted($event)"
            (itemsSorted)="onFolderStatesSorted($event)"></app-folder-states-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (edited)="onFolderStateEdited(context?.formContext.item)"
                    (displayed)="onFolderStateDisplayed(context?.formContext.item)"
                    (helped)="onFolderStatesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-folder-state-detail [context]="context" (folderStateUpdated)="onFolderStateUpdated($event)" (canceled)="onBackToList()"></app-folder-state-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
